exports.components = {
  "component---src-pages-aqi-js": () => import("./../../../src/pages/aqi.js" /* webpackChunkName: "component---src-pages-aqi-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

